import usePropsContext from '/druid/internal/usePropsContext';

export default function useHeight() {
  const { height } = usePropsContext();

  return [height];
}
